import React, { useState, useEffect, useCallback } from "react";
import APIService from "../../Services/API/APIService";
import {
  Grid,
  Segment,
  Dimmer,
  Loader,
  Container,
  Button
} from "semantic-ui-react";

import Payment from "./Payment";
import { toast } from "react-toastify";
import ProductType from "../../Data/ProductTypes";
import { useNavigate, useResolvedPath } from "react-router-dom";
import dayjs from "dayjs";
import numeral from "numeral";


const Checkout = (props) => {

  const [user] = useState(APIService.fetchUser());
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState();
  const navigate = useNavigate('')
  const url = useResolvedPath('').pathname

  async function removeItem(reload) {
    localStorage.removeItem('cartId')
    localStorage.removeItem('payload')
    localStorage.removeItem('setupTime')

    if (reload) {

      await APIService.postData("/checkout/clearCurrentCartGuestHouse", {
        cartId: localStorage.getItem('cartId')
      });

      window.location.reload()
    }
  }

  var hours = 5;
  var now = new Date().getTime();
  var setupTime = localStorage.getItem('setupTime');
  if (setupTime == null) {
    localStorage.setItem('setupTime', now)
  } else {

    if (now - setupTime > hours * 60 * 60 * 1000) {
      removeItem('reload')
    }
  }
  const booking = JSON.parse(localStorage.getItem('payload'))

  const fetchData = useCallback(async (isSubscribed) => {
    try {

      setLoading(true);

      const cartId = localStorage.getItem('cartId')
      let result = await APIService.getData("/checkout/getGuestHouseCartDetails", {
        cartId: cartId,
        customerEmail: booking?.email
      });
      if (isSubscribed) {
        setCart(result);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [booking?.email])

  useEffect(() => {
    let isSubscribed = true
    fetchData(isSubscribed);
     return () => (isSubscribed = false)
  }, [fetchData]);


  const _completeBooking = async (paymentResponse, paymentMode, amountPaid) => {
    try {

      if (paymentResponse) {
        setLoading(true);
        let urlPath = paymentMode ? 'guestHouseBookAndPay' : 'guestHouseReservePayment'

        let response = await APIService.postData(`/checkout/${urlPath}`, {
          ...cart.summary,
          reference: paymentResponse.reference,
          paymentMode: paymentMode,
          booking: booking,
          cartId: localStorage.getItem('cartId'),
          amountPaid: amountPaid,
          checkout: props?.checked
        });


        if (response.success && !props.checkout) {
          removeItem()
          toast.success(response.message || "Booking submitted successfully");

          if (user?.group[0] === 'ADMIN' || user?.group[0] === 'SUPERADMIN') {
            props?.toggleModal(false);
            navigate(`${url}/success/${response.payReference}`)
          } else {

            navigate(`/customer/success/${response.payReference}`)
          }
          return true;

        } else if (response.success && props.checkout) {
          removeItem()
          props.checkout(false)
          props.toggleModal(false)
          return true;


        }

        else {
          toast.warning(response.message);
          return false;
        }

      }

    } catch (error) {
      toast.warn(typeof error === "string" ? error : error?.message || "Unable to submit booking. Please try again.");
      console.log("error", error);
      setLoading(false);
      return false;
    }
  };

  return (
    <div style={{ margin: 20 }}>

      {loading && (
        <Dimmer active inverted>
          <Loader > Processing  ... </Loader>
        </Dimmer>
      )}


      <p>Bank Name :  {ProductType.GUESTHOUSE.bank}</p>
      <p>Bank Account Name :  {ProductType.GUESTHOUSE.accountName}</p>
      <p>Bank Account Number :  {ProductType.GUESTHOUSE.accountNumber}</p>

      {cart && cart?.summary ? (
        <Grid textAlign="left" stackable>
          <Grid.Row>
            <Grid.Column>

              {

                (cart?.summary?.paymentStatus === "PENDING") && (
                  <>

                    <Grid.Row>
                      <Grid.Column>

                        <Payment
                          productType={ProductType.GUESTHOUSE.id}
                          amountDue={cart?.amount}
                          checkout={props?.checked}
                          reference={cart?.summary?.id}
                          reservationToken={booking?.reservationToken}
                          completeBooking={_completeBooking}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </>
                )

              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : (
        <></>
      )}

      {!props.checkout && (<Button style={{ backgroundColor: '#26f09e', color: '#000000' }} onClick={() => removeItem('reload')}>Cancel  Payment</Button>)}


      {booking && (
        <>

          <Segment inverted>
            <Container style={{ padding: '1.2em' }}>
              <Grid>

                <Grid.Row>
                  <Grid.Column width={8}>
                    <p> First Name</p>
                    <hr />
                    <p>Last Name  </p>
                    <hr />
                    <p>Email </p>
                    <hr />
                    <p>Phone </p>
                    <hr />
                    <p> Room Name</p>
                    <hr />
                    <p>Check IN  </p>
                    <hr />
                    <p>Check OUT </p>
                    <hr />
                    <p>Amount  </p>
                    <hr />
                    <p>Number of nights </p>
                    <hr />
                    <p> Total </p>
                    <hr />
                  </Grid.Column>
                  <Grid.Column width={8}>


                    <p> {booking?.firstname}</p>
                    <hr />
                    <p>  {booking?.lastname}</p>
                    <hr />
                    <p> {booking?.email}</p>
                    <hr />
                    <p>  {booking?.phone}</p>
                    <hr />
                    <p>{booking?.roomName}</p>
                    <hr />
                    <p> {dayjs(booking?.checkin).format("DD-MMM-YYYY")}</p>
                    <hr />
                    <p>{dayjs(booking?.checkout).format("DD-MMM-YYYY")}</p>
                    <hr />
                    <p>  ₦{numeral(booking?.price).format("0,0")}</p>
                    <hr />
                    <p> {booking?.nights}</p>
                    <hr />
                    <p>  ₦{numeral((booking?.price) * (booking?.nights)).format("0,0")}</p>
                    <hr />



                  </Grid.Column>
                </Grid.Row>
              </Grid>


            </Container>

          </Segment>
        </>
      )}

    </div>
  );
};

export default Checkout;
